export function is_cloneDeep(data) {
  // 判断传入的值类型
  if (!data) {
    return data;
  }
  if (typeof data !== "object") return data;
  if (data.constructor === Date) return new Date(data);
  if (data.constructor === RegExp) return new RegExp(data);

  // 开始克隆
  const clone = Array.isArray(data) ? [] : {};
  for (let key in data) {
    // 不克隆原型链上的属性和方法
    if (Object.prototype.hasOwnProperty.call(data, key)) {
      if (typeof data[key] === "object") {
        clone[key] = is_cloneDeep(data[key]);
      } else {
        clone[key] = data[key];
      }
    }
  }
  return clone
}